import { gql } from '@apollo/client';

/**
 * 站点内联 AB 映射保存（#6/G6）：replace 语义——整站 AB 映射集重写。A 地址由后端标准化算 coreHash。
 * 站点 saveCooperationWarehouse 保存成功后调用（同 #5 拆分「save 后跟一刀」模式）。
 * 对应 api-server PickupStationMaintainMutation.saveStationAbMappings。
 */
export const SAVE_STATION_AB_MAPPINGS = gql`
  mutation SaveStationAbMappings($input: SaveStationAbMappingsInput!) {
    saveStationAbMappings(input: $input)
  }
`;

export interface StationAbMappingInput {
  originAddressLine1: string;
  originAddressLine2?: string | null;
  originCity: string;
  originState: string;
  originZipcode: string;
  contactName?: string | null;
  contactPhone?: string | null;
  channelId?: number | null;
}

export interface SaveStationAbMappingsInput {
  cooperationWarehouseId: number;
  warehouseId: number;
  items: StationAbMappingInput[];
}

export interface SaveStationAbMappingsResponse {
  saveStationAbMappings: boolean;
}
